/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { scrollToSection, scrollToTop } from "../../utility/CommonFunctions";
import { Link } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { useDispatch } from "react-redux";
import { setActiveId } from "../../store/actions/UserActions";

export default function Footer() {
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <footer>
      <div className="top_footer" id="contact">
        {/* animation line */}
        <div className="anim_line dark_bg">
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
          <span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/anim_line.png`}
              alt="anim_line"
            />
          </span>
        </div>
        {/* container start */}
        <div className="container">
          {/* row start */}
          <div className="row">
            {/* footer link 1 */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="abt_side">
                <div className="logo">
                  {" "}
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/footer_logo.png`}
                    alt="image"
                  />
                </div>
                <ul>
                  <li>
                    <a href="mailto:support@dizixpert.com ">
                      support@dizixpert.com
                    </a>
                  </li>
                  <li>
                    <a href="tel:+919351207293">+919351111477</a>
                  </li>
                </ul>
                <ul className="social_media">
                  <li>
                    <a href="https://www.facebook.com/mybilty/" target="_blank">
                      <i className="icofont-facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/my.bilty/"
                      target="_blank"
                    >
                      <i className="icofont-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@MyBity" target="_blank">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={16}
                        height={16}
                        fill="currentColor"
                        className="bi bi-youtube"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {/* footer link 2 */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="links">
                <h3>Useful Links</h3>
                <ul>
                  <li>
                    <Link to={RoutesLink.home}>Home</Link>
                  </li>
                  <li>
                    <a href="#features">Features</a>
                  </li>
                  <li>
                    <Link
                      to={RoutesLink.ContactUs}
                      onClick={() => dispatch(setActiveId("contact-us"))}
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <a href="#getstarted">Download Now</a>
                  </li>
                </ul>
              </div>
            </div>
            {/* footer link 3 */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="links">
                <h3>Help &amp; Suport</h3>
                <ul>
                  <li>
                    <a href="#">FAQs</a>
                  </li>
                  <li>
                    <a
                      href="#how_it_work"
                      onClick={() => {
                        scrollToSection("how_it_work");
                        dispatch(setActiveId("how_it_work"));
                      }}
                    >
                      How it works
                    </a>
                  </li>
                  <li>
                    <Link
                      to={RoutesLink.termsConditions}
                      onClick={() => dispatch(setActiveId(""))}
                    >
                      Terms &amp; conditions
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RoutesLink.privacy_policy}
                      onClick={() => dispatch(setActiveId(""))}
                    >
                      Privacy policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RoutesLink.RefundCancellation}
                      onClick={() => dispatch(setActiveId(""))}
                    >
                      Refund & Cancellation
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RoutesLink.ReqDeactivate}
                      onClick={() => dispatch(setActiveId(""))}
                    >
                      Account Deactivation
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={RoutesLink.EraseData}
                      onClick={() => dispatch(setActiveId(""))}
                    >
                      Erase Account Data
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* row end */}
        </div>
        {/* container end */}
      </div>
      {/* last footer */}
      <div className="bottom_footer">
        {/* container start */}
        <div className="container">
          {/* row start */}
          <div className="row">
            <div className="col-12 col-md-6">
              <p>© Copyrights 2024. All rights reserved.</p>
            </div>
            <div className="col-12 col-md-6">
              <p className="text-center text-md-right">
                Powered by Dizixpert Techno Services Pvt. Ltd.
              </p>
            </div>
          </div>
        </div>
        {/* row end */}
      </div>
      {/* container end */}
      {/* go top button */}
      <div
        className="go_top"
        style={{
          opacity: isScrolled ? 1 : 0,
        }}
        onClick={() => {
          scrollToTop();
          dispatch(setActiveId(""));
        }}
      >
        <span>
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/go_top.png`}
            alt="image"
          />
        </span>
      </div>
    </footer>
  );
}
